import { render, staticRenderFns } from "./CertificadoRenderer.vue?vue&type=template&id=67bccac3"
import script from "./CertificadoRenderer.vue?vue&type=script&lang=js"
export * from "./CertificadoRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports